module.exports = __webpack_public_path__ + "img/01.b4ee82b6.jpg";